// extracted by mini-css-extract-plugin
export default {"pricing":"styles_pricing__3zb+G","pricing__row":"styles_pricing__row__s1yWh"};